module.exports = __webpack_public_path__ + "static/media/square.9ac5350a.svg";